import PropTypes from 'prop-types';

const ImageBG = ({ src, width = 100, height = 100, ...rest }) => (<span data-testid="image-bg"
    style={{
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        backgroundPosition: 'right',
        display: 'inline-block',
        backgroundImage: `url('${src}')`,
        width,
        height,
        ...rest,
    }}
/>);

ImageBG.propTypes = {
    src: PropTypes.string.isRequired,
    width: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    height: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
};
export default ImageBG;